import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/index';
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "alert-hint",
  style: {
    "margin-top": "8px"
  }
};
const _hoisted_2 = {
  class: "bgc_main"
};
const _hoisted_3 = {
  class: "keyword-actions"
};
const _hoisted_4 = {
  class: "dialog-footer"
};
import { ref, reactive, onMounted, nextTick } from 'vue';
import cusInput from '@components/cusInput.vue';
import ChooseKeyword from '../components/chooseKeyword.vue';
import useForm from '../hooks/form';
export default {
  __name: 'Tab3Dialog',
  emits: ['clickSure'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dialogVisible = ref(false);
    let selectFile = null;
    const formRef = ref();
    const chooseKeywordRef = ref();
    const selectedAll = ref([]);
    const formData = reactive({
      Source: '',
      Author: '',
      AuditStatus: 0,
      SeoKeywordList: ['', '', '']
    });
    const {
      validateForm
    } = useForm(formRef);
    const emit = __emit;
    // 表单验证规则
    const checkUrl = (rule, value, callback) => {
      const {
        field
      } = rule;
      if (value === '') {
        if (field === 'Source') return callback(new Error('请输入新闻来源'));
        if (field === 'Author') return callback(new Error('请输入作者'));
        if (field === 'SeoKeywordList.0' || field === 'SeoKeywordList.1' || field === 'SeoKeywordList.2') return callback(new Error('请输入关键词'));
      }
      return callback();
    };
    const calcCharLength = value => {
      let charCount = 0;
      for (let i = 0; i < value.length; i++) {
        const char = value.charAt(i);
        // 判断是否为汉字（Unicode范围：\u4e00-\u9fa5）
        if (/[\u4e00-\u9fa5]/.test(char)) {
          charCount += 2; // 汉字算2个字符
        } else {
          charCount += 1; // 其他字符算1个字符
        }
      }
      return charCount;
    };
    const rules = {
      'SeoKeywordList.0': [{
        required: true,
        validator: checkUrl,
        trigger: 'blur'
      }],
      'SeoKeywordList.1': [{
        required: true,
        validator: checkUrl,
        trigger: 'blur'
      }],
      'SeoKeywordList.2': [{
        required: true,
        validator: checkUrl,
        trigger: 'blur'
      }],
      'Source': [{
        required: true,
        validator: checkUrl,
        trigger: 'blur'
      }],
      'Author': [{
        required: true,
        validator: checkUrl,
        trigger: 'blur'
      }]
    };

    // 方法
    const openSelectKeyword = () => {
      // 从 SeoKeywordList 中获取所有非空关键词
      selectedAll.value = formData.SeoKeywordList.filter(keyword => keyword && keyword.trim() !== '');
      chooseKeywordRef.value.openDialog(selectedAll.value);
    };
    const confirmKeyword = data => {
      // 将选中的关键词填充到 SeoKeywordList 中
      data.forEach((keyword, index) => {
        if (index < formData.SeoKeywordList.length) {
          formData.SeoKeywordList[index] = keyword || '';
        }
        formRef.value?.validateField(`SeoKeywordList.${index}`);
      });
    };
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const handleSure = () => {
      formRef.value.validate().then(res => {
        for (let i = 0; i < formData.SeoKeywordList.length; i++) {
          if (calcCharLength(formData.SeoKeywordList[i]) < 6) {
            return ElMessage.error('关键词不能少于3个汉字,英文不能少于6个字');
          }
        }
        dialogVisible.value = false;
        emit('clickSure', formData, selectFile);
      }).catch(() => {});
    };
    const openDialog = file => {
      dialogVisible.value = true;
      selectFile = file;
      if (file) {
        formData.Source = file.newsSource || '';
        formData.Author = file.newsAuthor || '';
        formData.SeoKeywordList = file?.newsKeywords?.map(item => item) || ['', '', ''];
      } else {
        formData.Source = '';
        formData.Author = '';
        formData.SeoKeywordList = ['', '', ''];
      }
      nextTick(() => {
        formRef.value.clearValidate();
      });
    };

    // 生命周期
    onMounted(() => {});

    // 暴露方法
    __expose({
      openDialog,
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "geo-dialog",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        title: "批量设置",
        width: "860px",
        "close-on-click-modal": false,
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "info",
          text: "",
          bg: "",
          onClick: handleClose
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSure
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("确定", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "alert-hint"
        }, [_createElementVNode("div", null, " 1、根据联盟新闻平台的要求，以下内容均不能填写链接地址; "), _createElementVNode("div", null, "2、我们将在1-3个工作日内完成审核，如审核未通过或发布未成功，已扣除的条数将返回至您的账户中。")], -1)), !_unref(selectFile) ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 小贴士：批量设置操作后将对所有媒体生效，如果需要个性化操作请在单篇文章进行操作，关键词默认会读取当前生成文章的关键词 ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
          model: formData,
          rules: rules,
          "label-position": "top",
          ref_key: "formRef",
          ref: formRef,
          "label-width": "100px",
          class: "ruleForm bg py-4 px-3 mb-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "关键词：",
            required: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.SeoKeywordList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_form_item, {
                key: index,
                class: "mb-0 mr-2",
                prop: `SeoKeywordList.${index}`
              }, {
                default: _withCtx(() => [_createVNode(cusInput, {
                  modelValue: formData.SeoKeywordList[index],
                  "onUpdate:modelValue": $event => formData.SeoKeywordList[index] = $event,
                  modelModifiers: {
                    trim: true
                  },
                  class: "suggestion-input",
                  maxlength: 20,
                  placeholder: "请输入关键词"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                _: 2
              }, 1032, ["prop"]);
            }), 128)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: openSelectKeyword,
              link: ""
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("选择关键词", -1)]))]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "作者设置：",
            prop: "Author"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "328px"
              },
              modelValue: formData.Author,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.Author = $event),
              maxlength: "50",
              placeholder: "请输入作者"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新闻来源：",
            prop: "Source"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "328px"
              },
              modelValue: formData.Source,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.Source = $event),
              maxlength: "50",
              placeholder: "请输入新闻来源"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createVNode(ChooseKeyword, {
          ref_key: "chooseKeywordRef",
          ref: chooseKeywordRef,
          limit: formData.SeoKeywordList.length,
          onConfirm: confirmKeyword
        }, null, 8, ["limit"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};